import { DiscountType, ReleaseType, VoucherType } from '@ibk/shared-types';
export const formatPercent = (value) => {
    return new Intl.NumberFormat('pt-BR', {
        style: 'percent',
        maximumFractionDigits: 2,
        minimumFractionDigits: 2,
    }).format(value / 100);
};
export const formatPercentInverted = (value) => {
    const formattedValue = formatPercent(value);
    return formattedValue.replace(/^(\d{1,3}(\.\d{3})*),(\d{2})%$/, '% $1,$3');
};
export const formatMoney = (value) => {
    return new Intl.NumberFormat('pt-BR', {
        currency: 'BRL',
        style: 'currency',
    }).format(value);
};
export const getDiscountValue = (discountType, discountValue, t) => {
    if (discountType === DiscountType.PERCENTAGE) {
        return formatPercentInverted(discountValue ?? 0);
    }
    if (discountType === DiscountType.TOTAL) {
        return formatMoney(discountValue ?? 0);
    }
    return t('benefit-card.credit-discount.no-discount');
};
export const getRechargeDayDescription = (t, rechargeDayType, rechargeDay) => {
    const labels = {
        FIRST_WORKING_DAY: t('benefit-card.credit-release.first-working-day'),
        LAST_WORKING_DAY: t('benefit-card.credit-release.last-working-day'),
        FIXED_DAY: `${t('benefit-card.credit-release.every-day')} ${rechargeDay}`,
    };
    return labels[rechargeDayType ?? ''] || '';
};
export const getValueWithTranslation = (card, t) => {
    if (card.hasIndividualValue) {
        return t('benefit-card.value.per-beneficiary');
    }
    if (card.releaseType === ReleaseType.DAILY) {
        return `${formatMoney(card.amountDaily || 0)} ${t('benefit-card.value.per-day')}`;
    }
    if (card.releaseType === ReleaseType.MONTHLY) {
        return `${formatMoney(card.baseValue || 0)} ${t('benefit-card.value.per-month')}`;
    }
    return 'R$ 0,00';
};
export const VOUCHER_TYPE_TO_ICON = {
    [VoucherType.VA]: 'auxilioAlimentacao',
    [VoucherType.VR]: 'auxilioRefeicao',
    [VoucherType.VR_VA]: 'vrVa',
    [VoucherType.VA_PAT]: 'auxilioAlimentacao',
    [VoucherType.VR_PAT]: 'auxilioRefeicao',
};
export const VOUCHER_TYPE_TO_TITLE_KEY = {
    [VoucherType.VA]: 'benefit-card.title.food-voucher',
    [VoucherType.VR]: 'benefit-card.title.meal-voucher',
    [VoucherType.VR_VA]: 'benefit-card.title.vr-va',
    [VoucherType.VA_PAT]: 'benefit-card.title.food-voucher-pat',
    [VoucherType.VR_PAT]: 'benefit-card.title.meal-voucher-pat',
};
export const getTitleKey = (voucherType) => {
    return VOUCHER_TYPE_TO_TITLE_KEY[voucherType] || VOUCHER_TYPE_TO_TITLE_KEY[VoucherType.VR_VA];
};
export const getIconName = (voucherType) => {
    return VOUCHER_TYPE_TO_ICON[voucherType] || VOUCHER_TYPE_TO_ICON[VoucherType.VR_VA];
};
